import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { FiClock, FiUsers, FiTag } from "react-icons/fi";
import { budgetText, cardClass, splitList, timeAgo } from "./jobUtils";

export default function JobCard({ job, currency, index = 0 }) {
  const skills = splitList(job.skills).slice(0, 5);
  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.35, delay: Math.min(index, 6) * 0.05 }}
      whileHover={{ y: -4 }}
      className={`${cardClass} p-5 hover:border-accent-light transition-colors`}
    >
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div className="min-w-0">
          <Link to={`/co-work/jobs/${job.id}`} className="text-lg font-semibold text-white hover:text-accent-light transition-colors">
            {job.title}
          </Link>
          <p className="text-xs text-gray-400 mt-1 flex flex-wrap items-center gap-x-4 gap-y-1">
            <span className="flex items-center gap-1"><FiClock size={12} /> {timeAgo(job.created_at)}</span>
            {job.category && <span className="flex items-center gap-1"><FiTag size={12} /> {job.category}</span>}
            <span className="flex items-center gap-1"><FiUsers size={12} /> {job.proposals_count} proposal{job.proposals_count === 1 ? "" : "s"}</span>
          </p>
        </div>
        <span className="px-3 py-1 rounded-full bg-accent/15 text-accent-light text-sm font-semibold whitespace-nowrap">
          {budgetText(job, currency)}
        </span>
      </div>

      <p className="text-sm text-gray-300 mt-3 line-clamp-2">{job.description}</p>

      <div className="mt-4 flex flex-wrap items-center justify-between gap-3">
        <div className="flex flex-wrap gap-2">
          {skills.map((skill) => (
            <span key={skill} className="px-2.5 py-1 rounded-md bg-white/5 border border-navy-border text-xs text-gray-300">{skill}</span>
          ))}
        </div>
        <Link
          to={`/co-work/jobs/${job.id}`}
          className="px-4 py-1.5 rounded-full bg-brand-gradient text-white text-sm font-semibold shadow-md shadow-accent/20"
        >
          View &amp; Apply
        </Link>
      </div>
    </motion.div>
  );
}
